import { cn } from '~/utils/cn'
import { IconProps } from '../Icons'

export const IconCaret = ({ className }: IconProps) => (
  <svg
    className={cn('fill-current', className)}
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.230338 0.994633C-0.25696 0.565295 0.0740342 0 0.800384 0L7.19962 0C7.92597 0 8.25696 0.565295 7.76966 0.994633L4.57924 3.78533C4.25744 4.07156 3.74256 4.07156 3.42076 3.78533L0.230338 0.994633Z"
    />
  </svg>
)
